module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#gallery",
      toString: function () {
        return this.url;
      }
    }